import { useaxios } from "../../../utils/useaxios";
export default (text) => setname => setprice => setcode => clear => {
    // initDispatch({ type: 'loadingTrue' });
    useaxios('item/getitem.php', { text }).then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        } else if (res == "request_failed") {
            alert('no internet connection');
            return false;
        } else if (res.status == "ok") {
            setname(res.data[0].item_name);
            setprice(res.data[0].item_price);
            setcode(res.data[0].item_barcode);
        } else {
            setname('');
            setprice('')
            alert('کاڵا نەدۆزرایەوە');
        }
        // setloading(false);
    });
}